import React, { ElementType } from 'react';

import { ChildrenProps, cn } from '../../../utils';

import './Banner.scoped.scss';

export enum BannerType {
  INFO = 'banner--info',
  ALERT = 'banner--alert',
  WARNING = 'banner--warning',
  QUESTION = 'banner--question',
  REMINDER = 'banner--reminder',
}

type Props<T extends ElementType> = {
  type: BannerType;
} & ChildrenProps;

const Banner = <T extends ElementType = 'div'>({ children, type, ...props }: Props<T>) => {
  return (
    <>
      <div className={cn('banner', `${type}`)} {...props}>
        {children}
      </div>
    </>
  );
};

export default Banner;
